import { useCallback, useState } from 'react';
import { stripeApi } from '../firebase/functionsService';

// Felles logikk for å sende sjåføren til Stripe: onboarding (oppretter kontoen ved behov)
// eller innlogging til Express-dashboardet.
export function useStripeOnboarding() {
  const [busy,  setBusy]  = useState(false);
  const [error, setError] = useState('');

  async function redirect(getUrl) {
    setBusy(true);
    setError('');
    try {
      const { url } = await getUrl();
      window.location.href = url;
    } catch (err) {
      setError('Kunne ikke åpne Stripe. Prøv igjen, eller kontakt support.');
      setBusy(false);
    }
  }

  function startOnboarding() {
    return redirect(async () => {
      await stripeApi.createConnectAccount();
      return stripeApi.getConnectOnboardingUrl();
    });
  }

  function openDashboard() {
    return redirect(() => stripeApi.createConnectDashboardLink());
  }

  // Låser opp knappen igjen, f.eks. når siden gjenopprettes med tilbakeknappen.
  const reset = useCallback(() => setBusy(false), []);

  return { busy, error, startOnboarding, openDashboard, reset };
}
